











import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
@Component
export default class Topic extends Vue {
  @Prop() topic: any
}
